import React from 'react'
import { motion } from 'framer-motion'
import { useRevealInView } from '../../lib/useRevealInView'
import {
  REVEAL_IMAGE_DELAY,
  REVEAL_IMAGE_CLIP_DURATION,
  REVEAL_IMAGE_SCALE,
  REVEAL_IMAGE_SCALE_DURATION,
  REVEAL_IMAGE_Y,
  REVEAL_VIEWPORT,
  imageRevealTransition,
} from '../../lib/revealMotion'

/** Imagem: cortina + zoom-out — mesma animação em telemóvel, tablet e PC. */
export default function RevealImage({
  src,
  alt,
  className = '',
  wrapperClassName = '',
  delay = 0,
  clip = true,
  as = 'div',
  ...imgProps
}) {
  const { ref, revealed } = useRevealInView(REVEAL_VIEWPORT)
  const imageDelay = delay + REVEAL_IMAGE_DELAY
  const MotionWrapper = motion[as] || motion.div

  const hiddenClip = { clipPath: 'inset(100% 0 0 0)' }
  const visibleClip = { clipPath: 'inset(0% 0 0 0)' }
  const hiddenImage = { scale: REVEAL_IMAGE_SCALE, y: REVEAL_IMAGE_Y }
  const visibleImage = { scale: 1, y: 0 }

  return (
    <MotionWrapper
      ref={ref}
      className={`overflow-hidden ${wrapperClassName}`.trim()}
      initial={false}
      animate={clip ? (revealed ? visibleClip : hiddenClip) : undefined}
      transition={imageRevealTransition(revealed ? imageDelay : 0, revealed ? REVEAL_IMAGE_CLIP_DURATION : 0.35)}
    >
      <motion.img
        src={src}
        alt={alt}
        className={className}
        initial={false}
        animate={revealed ? visibleImage : hiddenImage}
        transition={imageRevealTransition(
          revealed ? imageDelay : 0,
          revealed ? REVEAL_IMAGE_SCALE_DURATION : 0.35
        )}
        {...imgProps}
      />
    </MotionWrapper>
  )
}
